<template>
  <div class="immobilie mb-n4 mt-3">
    <v-row :class="$vuetify.breakpoint.smAndUp ? 'space-between' : ''"
           no-gutters>
      <v-col cols="12"
             sm="6">
        <v-select 
                        v-model="bezug"
                        v-validate="{ required: true }"
                        :disabled="readonly"
                        :error-messages="errors.collect('objektbezug')"
                        :items="objektBezug"
                        data-vv-as="Objektbezug"
                        class="required"
                        data-vv-name="objektbezug"
                        :name="random123('objektbezug')"
                        label="Objektbezug"
                        @change="setArt"
                         />
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-select v-if="bezug"
                        :ref="key + 'bezug'"
                        v-model="art"
                        v-validate="{ required: true }"
                        :disabled="readonly"
                        :items="getObjektDefinition"
                        :error-messages="errors.collect('objektart')"
                        data-vv-as="Objektart"
                        class="required"
                        data-vv-name="objektart"
                        :name="random123('objektart')"
                        label="Objektart"
                        auto-select-first
                        @change="setUnit(true)"/>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-text-field v-if="unit"
                      :ref="key + 'unit'"
                      v-model="value"
                      v-validate="getRules()"
                      v-dmb-trim
                      :disabled="!!(art === 'GARAGE')"
                      :error-messages="errors.collect('objektvalue' + key)"
                      :data-vv-as="inKOMPEX ? 'Jahresbruttopacht' : (unit ? valErrorTexte[art] : (unit + 'PACHT'))"
                      class="required"
                      :name="'objektvalue' + key"
                      :label="inKOMPEX ? 'Jahresbruttopacht in € (inklusive Nebenkosten)' : unit"
                      :placeholder="inKOMPEX ? 'Jahresbruttopacht in €' : unit.replace('(inklusive Nebenkosten)','')"
                      @input="valueChanged(key)" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import twowayBindingMixin, { mapTwoWay } from '../../store/twowayBindingMixin';
import immobilienConfig from '../../store/config/immobilie';
import { mapState } from 'vuex';

export default {
  name: "ImmobilieData",
  mixins: [ twowayBindingMixin, ValidationMixin ],
  data: function () {
    return {
      objektBezug: immobilienConfig.bezug,
      unitLabels: immobilienConfig.unit,
      validationRules: immobilienConfig.rules,
      errorTexte: immobilienConfig.errortext,
      valErrorTexte: immobilienConfig.valerrortext
    };
  },
  computed: {
    ...mapTwoWay([
      'art',
      'bezug',
      'unit',
      'value',
      'key',
      'name'
    ]),
    ...mapState({
      activeStepNumber: state => state.s.gewerbe.activeStepNumber,
      deckungen: state => state.gewerbe.deckungen,
      zahlweise: state => state.gewerbe.vertrag.zahlweise
    }),
    getObjektDefinition() {
      let index = this.objektBezug.findIndex(bezug => this.bezug === bezug);
      return index > -1 ? immobilienConfig.art[index] : [];
    },
    getObjektArt(){
      return this.getObjektDefinition.find(oa => oa.value === this.art);
    },
    setName() {
      return (this.getObjektArt ? this.getObjektArt.value : "" ) + this.value;
    },
    readonly() {
      return this.activeStepNumber !== 1;
    },
    inKOMPEX() {
      return this.deckungen.some(d => d.immoRef === this.key && d.produkt === 'MIETZ');
    }
  },
  watch:{
    setName(){
        const formatedUnitValue = this.value ? this.getObjektArt.longunit + parseInt(this.value, 10).toLocaleString("de-DE") + " " + this.getObjektArt.shortunit : "";
        this.name = this.getObjektArt ? (`${this.getObjektArt.text} ${(this.getObjektArt.value === "GARAGE") ? "" : formatedUnitValue}`) : "";
    }
  },
  created() {
    //not active jet
    this.$validator.extend('maximum', {
      getMessage: function () {
        const limit = "24.000";
        return `Es können online bis zu ${limit} € angegeben werden`;
      }.bind(this),
      validate: function (value) {
        if (!this.value) {
          return true;
        }
        return !(value && this.value > 24000 );
      }.bind(this)
    });
  },
  methods: {
    valueChanged(key) {
      this.updatePrices();
      this.validationToast('objektvalue' + key);
    },
    validationToast(controlname) {
      this.$validator.validate(controlname).then( (result) => {
        if(!result) fnError(controlname); 
      });
      const fnError = (function(controlname){
          const maxerror = this.errors.items.filter(
            (er) => er.rule === "max_value"
                    && er.field === controlname);
          if( maxerror.length) {
            this.$store.dispatch('gewerbeShowDirektionsanfrage', {
              label: this.inKOMPEX ? "Jahresbruttopacht" : this.errorTexte[this.art],
              limit: ( +this.getRules().split(":").pop()).toLocaleString('de-DE')
            });
          }
      }).bind(this);
    },
    getRules() {
      return (this.art && this.validationRules[this.art]) ? this.validationRules[this.art] : "required";
    },
    setUnit(setfocus) {
      this.unit = (this.art && this.unitLabels[this.art]) ? this.unitLabels[this.art] : null;
      if(this.art && this.art === "GARAGE" ) {
        this.value = 1;
      } else {
        this.value = null;
      }
      this.updatePrices();
      this.errors.clear();
      this.$nextTick(() => {
        this.$validator.reset();
        if (setfocus) this.$refs[this.key + "unit"].focus();
      });
    },
    setArt() {
      if(!this.getObjektArt) {
        this.art = null;
        this.setUnit(false);
      }
      this.$nextTick(() => {
        this.$refs[this.key + "bezug"].focus();
      });
    },
    updatePrices() {
      if (this.$store.state.gewerbe.ui.matrixSelection.produkte.length > 0) {

        // for Zusatzbaustein gew. verm. Immobilien: update Zusatzdeckung
        if (this.deckungen.find(d => d.immoRef === this.key && d.produkt === 'MIETZ')) {
          this.$store.dispatch('gewerbeRemoveZusatzDeckung', { person: 'vn1', produkt: 'MIETZ', immoRef: this.key });
          this.$store.dispatch('gewerbeAddZusatzDeckung', {
            person: 'vn1',
            produkt: 'MIETZ',
            sb: this.$store.state.gewerbe.ui.matrixSelection.sb,
            immobilie: this.key
          });
        }

        // else update Deckungen for the products selected in the matrix
        else {
          this.$store.dispatch('gewerbeUpdateMatrixDeckung', this.$store.state.gewerbe.ui.matrixSelection);
        }
      } 
    }
  }
};
</script>
<style>
  .v-list-item {
    min-height: 36px !important; /* overwrite vuetify from 48px */
  }
  .v-list-item__content{
    padding-bottom: 8px;  /* overwrite vuetify from 12px */
    padding-top: 8px;
  }

  .immobilie .v-input--is-disabled .v-input__icon--append{
    visibility: hidden !important; /* hide dropdown button if control is disabled */
  }
</style>